import { render, staticRenderFns } from "./SuccessCreate.vue?vue&type=template&id=117e66d1&scoped=true&"
import script from "./SuccessCreate.vue?vue&type=script&lang=js&"
export * from "./SuccessCreate.vue?vue&type=script&lang=js&"
import style0 from "./SuccessCreate.vue?vue&type=style&index=0&id=117e66d1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e66d1",
  null
  
)

export default component.exports